export default __webpack_public_path__ + "7450215c0157fba9560d6b0cc186435e.png";